/**
 * We should send date of birth to API as this format.
 */
module.exports = {
  DATE_OF_BIRTH_FORMAT: 'YYYY-MM-DD HH:mm:ss',
};



// WEBPACK FOOTER //
// ./src/constants/DateOfBirthFormat.js